import avatarModule from '../avatarModule';
// /
// This directive manages losing focus for non-input elements when you click elsewhere on a page
// It uses the "active" attribute of the item
// e.g. <div blur-target="item" on-blur="callThisFuncOnBlur()">
// If you set item.active = true in the controller, it will start watching the DOM for mouse clicks
// If a mouse click occurs outside the element, item.active will be set to false

function onBlur($document, $log, $timeout) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      blurTarget: '=',
      onBlur: '&'
    },
    link(scope, element, attrs) {
      const item = scope.blurTarget; // assume item has "active" property

      var onClick = event => {
        if (element.has(event.target).length > 0) {
          $log.debug('clicked inside element');
        } else {
          $log.debug('clicked outside element');
          $document.off('click touchstart', onClick);
          item.active = false;
          scope.$apply();
          scope.$apply(scope.onBlur());
        }
      };

      const toggleWatcher = scope.$watch('blurTarget.active', function(value) {
        if (typeof item.active === 'undefined') {
          return;
        }

        if (item.active) {
          $log.debug('binding click handler');
          // timeout so click handler has time to complete
          $timeout(function() {
            $document.on('click touchstart', onClick);
          }, 0);
        } else {
          $log.debug('unbinding click handler');
          $document.off('click touchstart', onClick);
        }
      });

      scope.$on('$destroy', function() {
        if (toggleWatcher) {
          toggleWatcher();
        }
        $document.off('click touchstart', onClick);
      });
    }
  };
}

avatarModule.directive('onBlur', onBlur);

export default onBlur;
